
/* global femcare */

femcare.general.accordion = {
    /**
     * Initializes accordion components using buttons for toggling.
     * @param {string} selector - The CSS selector for targeting accordion containers.
     */
    init: function (selector) {
        const accordionContainers = document.querySelectorAll(selector);

        accordionContainers.forEach((accordion) => {
            let currentlyOpenAccordion = null;
            const accordionHeaders = accordion.querySelectorAll('.accordion__header');

            accordionHeaders.forEach((accordionHeader) => {
                const accordionBody = accordionHeader.nextElementSibling;
                const toggleIcon = accordionHeader.querySelector('.accordion__toggle-icon');

                accordionHeader.addEventListener('click', () => {
                    const isExpanded = accordionHeader.getAttribute('aria-expanded') === 'true';

                    // Close the currently open accordion if it’s different from the clicked one
                    if (currentlyOpenAccordion && currentlyOpenAccordion !== accordionHeader) {
                        femcare.general.accordion.closeAccordion(currentlyOpenAccordion);
                    }

                    if (!isExpanded) {
                        femcare.general.accordion.openAccordion(accordionHeader, accordionBody, toggleIcon);
                        currentlyOpenAccordion = accordionHeader;
                    } else {
                        femcare.general.accordion.closeAccordion(accordionHeader);
                        currentlyOpenAccordion = null;
                    }
                });
            });
        });

        this.toggleViewAll();
    },

    /**
     * Opens a specified accordion item by expanding its body and updating accessibility attributes.
     * @param {HTMLElement} accordionHeader - The header button that toggles the accordion.
     * @param {HTMLElement} accordionBody - The accordion panel (body) associated with the header.
     * @param {HTMLElement} toggleIcon - The icon element that indicates expanded/collapsed state.
     */
    openAccordion: function (accordionHeader, accordionBody, toggleIcon) {
        accordionHeader.setAttribute('aria-expanded', 'true');
        accordionBody.removeAttribute('inert');
        accordionBody.classList.add('expanded');
        if (toggleIcon) {
            toggleIcon.classList.add('accordion__toggle-icon--expanded');
        }
    },

    /**
     * Closes a specified accordion item by collapsing its body and updating accessibility attributes.
     * @param {HTMLElement} accordionHeader - The header button that toggles the accordion.
     */
    closeAccordion: function (accordionHeader) {
        accordionHeader.setAttribute('aria-expanded', 'false');
        const accordionBody = accordionHeader.nextElementSibling;
        const toggleIcon = accordionHeader.querySelector('.accordion__toggle-icon');
        accordionBody.setAttribute('inert', '');
        accordionBody.classList.remove('expanded');
        if (toggleIcon) {
            toggleIcon.classList.remove('accordion__toggle-icon--expanded');
        }
    },

    /**
     * Toggles the "View All / View Less" behavior for all accordions on the page.
     * When active, all accordion items are shown - when collapsed, the list is
     * restored to its initial state by displaying only the first 5 items.
     */
    toggleViewAll: function () {
        const toggleBtns = document.querySelectorAll(".accordion-action");

        toggleBtns.forEach(btn => {
            btn.addEventListener("click", () => {

                const accordion = btn.previousElementSibling;
                const items = accordion.querySelectorAll(".accordion__item");
                const isOpen = btn.getAttribute("aria-expanded") === "true";
                if (isOpen) {
                    items.forEach((item, index) => {
                        item.classList.toggle("hidden", index >= 5);
                    });

                    btn.textContent = btn.dataset.viewAllText;
                    accordion.scrollIntoView({ behavior: 'smooth', block: 'center' });
                } else {
                    items.forEach(item => {
                        item.classList.remove("hidden")
                    });

                    btn.textContent = btn.dataset.viewLessText;
                }

                btn.setAttribute("aria-expanded", (!isOpen).toString())
            });
        });
    }
};
